// Utility function to convert blog title to URL-friendly slug
export const createSlug = (title) => {
  if (!title) return '';
  
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
};

// Function to extract ID from slug-based URL
export const extractIdFromSlug = (slug) => {
  // If slug contains a number at the end, extract it
  const match = slug.match(/-(\d+)$/);
  return match ? match[1] : null;
};

// Function to create slug with ID
export const createSlugWithId = (title, id) => {
  const slug = createSlug(title);
  return `${slug}`;
};

// Function to create section ID from heading text
export const createSectionId = (headingText) => {
  return createSlug(headingText);
};
